import _ from 'underscore';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { RANGES } from '@bingads-webui/date-ranges';
import template from './date-filter-dropdown-template.pug';

/**
 * The dropdown view that will show the date
 * range selections made by the user.
 * @class DateFilterDropdownView
 * @extends {View}
 * @param {Object} selection - The selected date ranges
 */
export class DateFilterDropdownView extends DeterministicView {
  /**
   * Initialize the DateFilterDropdownView
   * @param {Object} options - View constructor options
   * @returns {void}
   */
  initialize(options) {
    this.options = options;
    this.RANGES = RANGES;
  }

  /**
   * Set the state of the dropdown view
   * @param {Object} selection - The selected date ranges
   * @returns {Object} this
   */
  setState({ selection }) {
    const { primaryRange } = selection;
    const comparedRange = {
      start: _.result(selection.comparedRange, 'start'),
      end: _.result(selection.comparedRange, 'end'),
      text: _.result(selection.comparedRange, 'text'),
    };
    this.model.set({ primaryRange, comparedRange });
    return this;
  }

  get template() {
    return template;
  }
}
